import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Reads ?highlightOrderId=… so a page can scroll to and flag an order
const INITIAL_DOCUMENT_SEARCH = typeof window === 'undefined' ? '' : window.location.search;
const IS_RELOADED_DOCUMENT = (() => {
  if (typeof performance === 'undefined' || !performance.getEntriesByType) {
    return false;
  }
  return performance.getEntriesByType('navigation')[0]?.type === 'reload';
})();
let hasClearedReloadedHighlight = false;

// Reads ?highlightOrderId=… so a page can scroll to and flag an order. A portal
// reload of such a URL drops the param and highlights nothing.
const useHighlightOrderId = (basePath) => {
  const location = useLocation();
  const navigate = useNavigate();

  const highlightOrderId = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get('highlightOrderId');
  }, [location.search]);

  const isReloadedHighlight =
    IS_RELOADED_DOCUMENT &&
    !hasClearedReloadedHighlight &&
    location.search === INITIAL_DOCUMENT_SEARCH;

  // Clear the highlight param on reload so a user can refresh the page without it re-highlighting the same order.
  useEffect(() => {
    if (!highlightOrderId || !isReloadedHighlight) {
      return;
    }
    hasClearedReloadedHighlight = true;
    navigate(basePath, { replace: true });
  }, [highlightOrderId, isReloadedHighlight, navigate, basePath]);

  return isReloadedHighlight ? null : highlightOrderId;
};

export default useHighlightOrderId;
